import theme from '@styles/theme';

export default {
  configuratorContainer: (configuratorLoading: boolean) => ({
    margin: 'auto',
    width: '100%',
    mt: configuratorLoading ? 0 : ['-52px', '-52px', '-100px'],
    pt: ['52px', '52px', '100px'],
    minHeight: '720px !important',
  }),
  configuratorContent: {
    position: 'relative',
    p: ['0 16px 40px', '0 16px 40px', '20px 24px 64px', '20px 24px 64px', '64px 40px 80px'],

    '.vpw-configurator__content': {
      maxWidth: '100%',
    },
    '.vpw-configurator': {
      maxWidth: '1920px !important',
      margin: 'auto',

      '.vpw-quantity__content': {
        border: '1px solid #d8d3d2',
        height: '28px',
      },
    },

    '.vpw-quantity__input-arrow': {
      '&.up, &.down': {
        padding: 0,
        height: '14px',
        border: 'none',
      },
      '&.up': {
        transform: 'translateY(1px)',
      },
      '&.down': {
        transform: 'translateY(-1px)',
      },
    },

    '.vpw-quantity__input': {
      border: 'none',
    },

    '.icon-caret-up:before': {
      content: '""',
      position: 'absolute',
      width: 0,
      height: 0,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
      borderBottom: '4px solid black',
    },

    '.icon-caret-down:before': {
      content: '""',
      position: 'absolute',
      width: 0,
      height: 0,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
      borderTop: '4px solid black',
    },

    '.vpw-configurator__gallery': {
      width: ['', '', '', '', 'calc(100% - (650px + 20px))'],
      '.vpw-gallery': {
        margin: ['', '', '', '', 'auto'],
        '.vpw-gallery__navigation--left': {
          left: ['none', 'none', 'none', 'none', 'none', 'none'],
          background: 'none',
          '&:before': {
            content: '"\\e90c"',
            fontFamily: 'vox-ds-icons',
            fontSize: '31px',
            color: theme.rawColors.darkGrey700,
            lineHeight: '1',
          },
        },
        '.vpw-gallery__navigation--right': {
          right: ['none', 'none', 'none', '-2vw', '-2vw', '-2vw'],
          background: 'none',
          '&:before': {
            content: '"\\e90c"',
            fontFamily: 'vox-ds-icons',
            fontSize: '31px',
            color: theme.rawColors.darkGrey700,
            lineHeight: '1',
          },
        },
      },
    },

    '.vpw-setting': {
      width: ['', '', '', '', '650px'],
    },

    '.col-user-menu #mainMenu': {
      position: 'relative',
    },

    // NOTE: Additional Creative configurator styling
    '.v-application': {
      maxWidth: '1920px',
      margin: 'auto',
    },
    '.tiny-creative .creative-item-label-container label': {
      display: 'block !important',
      lineHeight: '15px !important',
    },

    '.creative-action-cart-price-vox button.price': {
      padding: '0 !important',
      height: 'auto !important',
      minHeight: '60px',
    },

    '.creative-action-add-to-cart-vox button.add-to-cart': {
      height: 'auto !important',
      minHeight: '60px',
    },

    '.card-actions-left button': {
      height: 'auto !important',
      minHeight: '60px',
    },

    '.creative-quantity-section': {
      right: '0 !important',
    },

    '.vpw-quantity__content': {
      display: 'inline-block',
      marginLeft: '6px',
    },

    '.tiny-creative .creative-unit-container': {
      paddingTop: '0',
    },

    '.creative-menu .creative-panels-section': {
      marginTop: '0 !important',
    },

    '.creative-product-dialog-container': {
      '.product-modal-header p': {
        fontFamily: `${theme.fonts.uniformMedium} !important`,
        fontWeight: `${theme.fontWeights.medium} !important`,
      },

      '.row:nth-of-type(1) .col': {
        paddingBottom: '0 !important',
      },

      '.row:nth-of-type(2) .col': {
        paddingTop: '0 !important',
      },

      '.row:nth-of-type(4) p': {
        fontSize: '14px !important',
      },
    },
    '.mobile-additional-action .row': {
      'div:nth-of-typed(3), div:nth-of-type(5)': {
        display: 'none  !important',
      },
    },
    '.creative-action-download-images-vox': {
      display: 'none  !important',
    },
  },
  loading: {
    maxHeight: 'calc(720px - 52px)',
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
  },
  mainContainer: {
    minHeight: '60vh',
  },
};
